module.exports = __webpack_public_path__ + "img/deduction-table-icon.dc3bb14d.svg";